import {
  ChangeDetectionStrategy,
  Component,
  Input,
  inject,
} from '@angular/core';
import {
  Activity,
  RoleAction,
  RolePermissionSubject,
  Shift,
} from '@wilson/interfaces';

import { TranslatePipe } from '@ngx-translate/core';
import { NzDropdownModule } from 'ng-zorro-antd/dropdown';
import { DuplicateShiftActionService } from './duplicate-shift-action.service';
import { AuthorizationModule } from '@wilson/authorization';
import { NzTooltipModule } from 'ng-zorro-antd/tooltip';
import { AbilityServiceSignal } from '@casl/angular';
@Component({
  selector: 'wilson-duplicate-shift-action',
  imports: [
    TranslatePipe,
    NzDropdownModule,
    AuthorizationModule,
    NzTooltipModule,
  ],
  templateUrl: './duplicate-shift-action.component.html',
  styleUrl: './duplicate-shift-action.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DuplicateShiftActionComponent {
  private readonly duplicateShiftActionService = inject(
    DuplicateShiftActionService,
  );

  @Input({
    required: true,
  })
  shift!: Shift & { activities: Activity[] };

  @Input()
  openInNewTab = false;

  protected RoleAction = RoleAction;
  protected RolePermissionSubject = RolePermissionSubject;
  protected can = inject(AbilityServiceSignal).can;

  duplicateShift(): void {
    this.duplicateShiftActionService.prepareDuplicateShiftDataAndRedirect(
      this.shift,
      this.openInNewTab,
    );
  }
}
